export const placeOptions = [
    {
        label: '北京市',
        value: '北京市'
    },
    {
        label: '天津市',
        value: '天津市'
    },
    {
        label: '上海市',
        value: '上海市'
    },
    {
        label: '重庆市',
        value: '重庆市'
    },
    {
        label: '河北省',
        value: '河北省'
    },
    {
        label: '山西省',
        value: '山西省'
    },
    {
        label: '辽宁省',
        value: '辽宁省'
    },
    {
        label: '吉林省',
        value: '吉林省'
    },
    {
        label: '黑龙江省',
        value: '黑龙江省'
    },
    {
        label: '福建省',
        value: '福建省'
    },
    {
        label: '江西省',
        value: '江西省'
    },
    {
        label: '江苏省',
        value: '江苏省'
    },
    {
        label: '浙江省',
        value: '浙江省'
    },
    {
        label: '安徽省',
        value: '安徽省'
    },
    {
        label: '山东省',
        value: '山东省'
    },
    {
        label: '河南省',
        value: '河南省'
    },
    {
        label: '湖北省',
        value: '湖北省'
    },
    {
        label: '湖南省',
        value: '湖南省'
    },
    {
        label: '广东省',
        value: '广东省'
    },
    {
        label: '海南省',
        value: '海南省'
    },
    {
        label: '四川省',
        value: '四川省'
    },
    {
        label: '贵州省',
        value: '贵州省'
    },
    {
        label: '云南省',
        value: '云南省'
    },
    {
        label: '陕西省',
        value: '陕西省'
    },
    {
        label: '甘肃省',
        value: '甘肃省'
    },
    {
        label: '青海省',
        value: '青海省'
    },
    {
        label: '台湾省',
        value: '台湾省'
    },
    {
        label: '内蒙古自治区',
        value: '内蒙古自治区'
    },
    {
        label: '广西壮族自治区',
        value: '广西壮族自治区'
    },
    {
        label: '西藏自治区',
        value: '西藏自治区'
    },
    {
        label: '宁夏回族自治区',
        value: '宁夏回族自治区'
    },
    {
        label: '新疆维吾尔族自治区',
        value: '新疆维吾尔族自治区'
    },
    {
        label: '香港特别行政区',
        value: '香港特别行政区'
    },
    {
        label: '澳门特别行政区',
        value: '澳门特别行政区'
    }
];

export const regionOptions = [
    {
        label: '生产设备监控',
        value: '生产设备监控'
    },
    {
        label: '生产环境监控',
        value: '生产环境监控'
    },
    {
        label: '智慧工地',
        value: '智慧工地'
    },
    {
        label: '老旧改造',
        value: '老旧改造'
    },
    {
        label: '电力抄表',
        value: '电力抄表'
    },
    {
        label: '电力保护设备',
        value: '电力保护设备'
    },
    {
        label: '电能质量管理',
        value: '电能质量管理'
    },
    {
        label: '自主共享',
        value: '自主共享'
    },
    {
        label: '充电桩',
        value: '充电桩'
    },
    {
        label: '智慧校园',
        value: '智慧校园'
    },
    {
        label: '环境监测',
        value: '环境监测'
    },
    {
        label: '环保设备',
        value: '环保设备'
    },
    {
        label: '畜牧养殖',
        value: '畜牧养殖'
    },
    {
        label: '大田农村节水灌溉',
        value: '大田农村节水灌溉'
    },
    {
        label: '农水灌溉计价系统',
        value: '农水灌溉计价系统'
    },
    {
        label: '智慧农业大棚',
        value: '智慧农业大棚'
    },
    {
        label: '农机/水肥一体机监控',
        value: '农机/水肥一体机监控'
    },
    {
        label: '换热站监控',
        value: '换热站监控'
    },
    {
        label: '供暖平衡阀',
        value: '供暖平衡阀'
    },
    {
        label: '城市供水',
        value: '城市供水'
    },
    {
        label: '城市综合管廊',
        value: '城市综合管廊'
    },
    {
        label: '电气火灾监控',
        value: '电气火灾监控'
    },
    {
        label: '消防报警主机联网',
        value: '消防报警主机联网'
    },
    {
        label: '工业可燃气体报警',
        value: '工业可燃气体报警'
    },
    {
        label: '消防水压监控',
        value: '消防水压监控'
    },
    {
        label: '其他',
        value: '其他'
    }
];

